import httpRequest from "../ajax";

const contactImportService = {
  recordConsent: async () => {
    const response = await httpRequest("post", "/contacts/consent", {});
    return response.data;
  },

  getGoogleAuthUrl: async (returnPath = "/home") => {
    const response = await httpRequest(
      "get",
      `/contacts/import/google/start?return_path=${encodeURIComponent(returnPath)}`
    );
    return response.data;
  },

  reimportGoogle: async () => {
    const response = await httpRequest("post", "/contacts/import/google", {});
    return response.data;
  },

  importCsv: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await httpRequest("post", "/contacts/import/csv", formData);
    return response.data;
  },

  getContacts: async () => {
    const response = await httpRequest("get", "/contacts");
    return response.data;
  },

  sendInvites: async (contactIds) => {
    const response = await httpRequest("post", "/contacts/invite", {
      contact_ids: contactIds,
    });
    return response.data;
  },

  getStats: async () => {
    const response = await httpRequest("get", "/contacts/invite/stats");
    return response.data;
  },

  deleteAllContacts: async () => {
    const response = await httpRequest("delete", "/contacts");
    return response.data;
  },

  dismissNudge: async () => {
    const response = await httpRequest("post", "/contacts/nudge/dismiss", {});
    return response.data;
  },

  recordTier3Share: async () => {
    const response = await httpRequest("post", "/contacts/nudge/tier3-share", {});
    return response.data;
  },
};

export default contactImportService;
